import api from './utilBackoffice';

const controller = 'EnvioArquivo';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: dto => {
    return api.Axios.GetParams(url, dto);
  },

  ListarTentativas: dto => {
    return api.Axios.GetParams(url + '/ListarTentativas', dto);
  }
});
